var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagOther = function SvgFlagOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 5.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M17 4H3a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 3 16h14a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 17 4M3 3.5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0AD2D2",
    fillRule: "evenodd",
    d: "M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-.747.364a3.28 3.28 0 0 1-2.044 2.678c.355-.722.562-1.663.602-2.678zM10 13.273q.105 0 .21-.007c.5-.591.82-1.676.873-2.902H8.917c.053 1.226.373 2.31.873 2.902q.105.007.21.007m-1.21-.23a3.28 3.28 0 0 1-2.043-2.68H8.19c.04 1.016.247 1.957.601 2.68m.127-3.407h2.166c-.053-1.226-.373-2.31-.873-2.902a3 3 0 0 0-.42 0c-.5.591-.82 1.676-.873 2.902M8.79 6.958c-.354.722-.561 1.663-.601 2.678H6.747A3.28 3.28 0 0 1 8.79 6.958m4.463 2.678H11.81c-.04-1.015-.247-1.956-.602-2.678a3.28 3.28 0 0 1 2.044 2.678",
    clipRule: "evenodd"
  })));
};
export default SvgFlagOther;